// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\Billing\DraftChargeCollection.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { DraftCharge, DraftChargeData, DraftChargeOptions } from 'data/models/DraftCharge';

// DraftChargeCollectionData is the class that DraftChargeCollection serializes to/from
export interface DraftChargeCollectionData {
    Id : number;
	
    Charges : DraftChargeData[] | null;
	
}

// DraftChargeCollectionOptions is the class which may be passed to the DraftChargeCollection constructor to define optional initial data values
export interface DraftChargeCollectionOptions {
    Id : number;
	
    Charges? : DraftChargeOptions[] | null;
	
}

export class DraftChargeCollection {
    public Id : DataSignal<number>;
	
    public Charges : SDataArray<DraftCharge>;
	

    constructor();
    constructor(data : DraftChargeCollectionOptions);
    constructor(data: DraftChargeCollectionOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Charges = SArray<DraftCharge>([]);
	    
    }

    static key(obj : DraftChargeCollection) {
        return obj.Id();
    }
    
    static dataKey(obj : DraftChargeCollectionOptions) {
        return obj.Id;
    }

    static update(obj : DraftChargeCollection, data : DraftChargeCollectionOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/DraftChargeCollection.ts